import { baseUrl, sgBaseUrl } from '@fs/zion-config'

export default [
  'integration.familysearch.org',
  'beta.familysearch.org',
  'www.familysearch.org',
  'integration-ru.familysearch.org',
  'beta-ru.familysearch.org',
  'www-ru.familysearch.org',
  'ancestors.familysearch.org',
  'ancestors-integ.familysearch.org',
  'ancestorsbeta.familysearch.org',
  baseUrl,
  sgBaseUrl,
]
